import FormCurrencyInput from './FormCurrencyInput';

export default FormCurrencyInput;
